import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../Graphs.module.scss";
import { useState } from "react";

type ReportFiltersMenuProps = {
  open: boolean;
  zipCodeFilterValue: string;
  handleApplyFilters: () => void;
  handleResetFilters: () => void;
  setZipCodeFilterValue: React.Dispatch<React.SetStateAction<string>>;
};

const ReportFiltersMenu = ({
  open,
  zipCodeFilterValue,
  handleApplyFilters,
  handleResetFilters,
  setZipCodeFilterValue,
}: ReportFiltersMenuProps) => {
  const ZIP_CODE_REGEX = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/);
  const urlParams = new URLSearchParams(window.location.search);
  const expansionLimitParam = urlParams.get("expansionLimit");
  const [expansionLimitValue, setExpansionLimitValue] = useState<string>(
    expansionLimitParam || "15"
  );
  const isZipCodeFilterValueValid = zipCodeFilterValue.length
    ? ZIP_CODE_REGEX.test(zipCodeFilterValue)
    : true;

  const handleExpansionLimitChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setExpansionLimitValue((event.target as HTMLInputElement).value);
  };

  const handleZipCodeFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setZipCodeFilterValue((event.target as HTMLInputElement).value);
  };

  return (
    <Box
      visibility={open ? "visible" : "hidden"}
      sx={{
        bgcolor: styles.backgroundWhite,
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        top: 70,
        width: "290px",
        height: "70vh",
        overflowY: "auto",
        position: "absolute",
        right: "2.5%",
      }}
    >
      {/* ================ F I L T E R S   M E N U   T I T L E ================ */}
      <Box
        sx={{
          bgcolor: "rgba(33, 85, 133, 10%)",
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          color: styles.mainBlue,
          fontSize: "16px",
          fontWeight: 500,
          lineHeight: "24px",
          padding: "12px 16px",
        }}
      >
        Filters
      </Box>

      {/* ================ F I L T E R S   M E N U   C O N T E N T ================ */}
      <Box
        sx={{
          maxHeight: "75.5%",
          overflow: "auto",
        }}
      >
        <Box padding="24px 16px">
          <Typography
            variant="body1"
            color={styles.mainBlue}
            marginBottom="8px"
          >
            Expansion Limit:
          </Typography>
          <Typography variant="caption" color={styles.mainBlue}>
            Define the maximum number of subnodes you want to see for each node.
          </Typography>

          <RadioGroup
            aria-labelledby="expansion-limit-radio-buttons-group"
            name="expansion-limit-radio-buttons-group"
            sx={{ padding: "12px 12px 0 12px" }}
            value={expansionLimitValue}
            onChange={handleExpansionLimitChange}
          >
            <FormControlLabel
              value="all"
              control={
                <Radio
                  sx={{
                    color: styles.mainBlue,
                    "&.Mui-checked": { color: styles.mainBlue },
                  }}
                />
              }
              label="View All"
            />
            <FormControlLabel
              value="5"
              control={
                <Radio
                  sx={{
                    color: styles.mainBlue,
                    "&.Mui-checked": { color: styles.mainBlue },
                  }}
                />
              }
              label="View 5"
            />
            <FormControlLabel
              value="10"
              control={
                <Radio
                  sx={{
                    color: styles.mainBlue,
                    "&.Mui-checked": { color: styles.mainBlue },
                  }}
                />
              }
              label="View 10"
            />
            <FormControlLabel
              value="15"
              control={
                <Radio
                  sx={{
                    color: styles.mainBlue,
                    "&.Mui-checked": { color: styles.mainBlue },
                  }}
                />
              }
              label="View 15"
            />
          </RadioGroup>
        </Box>

        <Divider
          flexItem
          sx={{
            bgcolor: styles.dividerGray,
          }}
          variant="middle"
        />

        <Box padding="24px 16px">
          <Typography
            variant="body1"
            color={styles.mainBlue}
            marginBottom="16px"
          >
            Location
          </Typography>

          <TextField
            error={!isZipCodeFilterValueValid}
            fullWidth
            label="Zip Code"
            placeholder="Search by Zip Code"
            value={zipCodeFilterValue}
            onChange={handleZipCodeFilterChange}
          />
        </Box>
      </Box>

      {/* ================ F I L T E R S   M E N U   A C T I O N S ================ */}
      <Box
        display="flex"
        justifyContent="space-between"
        padding="16px 12px"
        boxShadow="0px 0px 4px 0px #00000040"
      >
        <Button
          className={styles.changeReportPageButton}
          disableElevation
          disableFocusRipple
          disableRipple
          sx={{
            width: "125px",
            ":hover": {
              backgroundColor: styles.backgroundWhite,
            },
          }}
          onClick={handleResetFilters}
        >
          Reset Filters
        </Button>

        <Button
          className={styles.saveTemplateButton}
          disableElevation
          disableFocusRipple
          disableRipple
          sx={{
            width: "125px",
            ":hover": {
              backgroundColor: styles.mainBlue,
            },
          }}
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
      </Box>
    </Box>
  );
};

export default ReportFiltersMenu;
